<app-creator-details-banner
  [creator]="creator()"
  [creatorMode]="creatorMode()"
  [adminMode]="adminMode()"
  [nameForm]="nameForm"
  [iconForm]="iconForm"
  [isEditingName]="isEditingName"
  [nameSaving]="isCreatingCreator()"
  [nameErrorMessage]="nameError()"
  (nameEditingChanged)="onBannerNameEditingChanged($event)"
  (imageSelected)="updateIcon()"
  (imageRemoved)="updateIcon()"
  (nameSaveRequested)="onBannerNameSaveRequested()"
  #bannerComponent
/>

<app-content-container class="w-fill-available">
  @if (!hideFilters()) {
    <div class="w-full relative">
      <app-creator-details-filters
        class="tab-group-filters"
        [channels]="creator()?.channels || []"
        [dateFilterState]="dateFilterState()"
        [loading]="store.loading$()"
        [socialContents]="socialContents()"
        [socialContentsOriginal]="socialContentsOriginal()"
        [creatorDetailsFilter]="creatorDetailsFilter()"
        (socialContentsChanged)="socialContents.set($event)"
        (creatorDetailsFilterChanged)="onCreatorDetailsFilterChanged($event)"
        (dateRangeChanged)="onDateRangeChanged($event)"
        (selectedRangeChanged)="onSelectedRangeChanged($event)"
      />
    </div>
  }

  <mat-tab-group class="w-full profile-tab-group" (selectedTabChange)="onSelectedTabChange($event)">
    <!-- <mat-tab>
      <ng-template mat-tab-label>
        <span>{{ 'pages.creatorDetails.tabs.overview' | translate }}</span>
      </ng-template>
      <div class="pt-[76px] min-h-[calc(100vh-400px)]">Overview here</div>
    </mat-tab> -->

    <mat-tab #campaignsTab *hasPermission="[EPermissions.campaignReadOwn]">
      <ng-template mat-tab-label>
        <span data-testid="creator-details-tab-campaigns">{{ 'pages.creatorDetails.tabs.campaigns' | translate }}</span>
      </ng-template>

      <div class="min-h-[calc(100vh-400px)] pt-7">
        @if (loadedCampaignsData() && campaigns().length === 0 && !hasUnfilteredCampaigns()) {
          <div class="flex justify-center w-full">
            <span class="opacity-50 text-center" data-testid="creator-details-tab-panel-campaigns">
              {{
                creatorMode()
                  ? ('pages.creatorDetails.youDoNotHaveAnyActiveCampaigns' | translate)
                  : ('pages.creatorDetails.creatorNotParticipatingInCampaigns' | translate)
              }}
            </span>
          </div>
        } @else {
          <app-campaigns-datatable
            data-testid="creator-details-tab-panel-campaigns"
            [campaigns]="campaigns()"
            [campaignsLoading]="campaignsStore.campaignsLoading$()"
            [showCreateButton]="false"
            [creatorMode]="creatorMode()"
            [total]="campaignsStore.total$()"
            [columns]="[
              'name',
              'status',
              'startFormatted',
              'endFormatted',
              'customer',
              'pay',
              'ctaKpiStatus',
              'actions',
            ]"
            [requestFilters]="{ campaign_creators__creator_id: creatorId() || creator()?.id }"
            [requestJoins]="['campaign_creators', 'campaign_creators.creator']"
            [creatorId]="creatorId() || creator()?.id"
          />
        }
      </div>
    </mat-tab>

    @if (!creatorMode()) {
      <mat-tab #deliverablesTab *hasPermission="[EPermissions.campaignAnalyticsReadOwn]">
        <ng-template mat-tab-label>
          <span data-testid="creator-details-tab-deliverables">{{
            'pages.creatorDetails.tabs.deliverables' | translate
          }}</span>
        </ng-template>

        <div class="min-h-[calc(100vh-400px)] pt-7">
          @if (deliverablesTabOpened()) {
            <app-creator-details-deliverables
              data-testid="creator-details-tab-panel-deliverables"
              [adminMode]="adminMode()"
              [creator]="creator()"
              [creatorId]="creatorId() || creator()?.id || ''"
            />
          }
        </div>
      </mat-tab>
    }

    <mat-tab #channelsTab>
      <ng-template mat-tab-label>
        <span data-testid="creator-details-tab-channels">{{ 'pages.creatorDetails.tabs.channels' | translate }}</span>
      </ng-template>

      <div class="min-h-[calc(100vh-400px)] pt-7">
        <app-creator-platform-list
          data-testid="creator-details-tab-panel-channels"
          [isEditingName]="!creator()"
          [creator]="creator()!"
          [loading]="!loadedCreatorData()"
          [iconFormValue]="iconForm.controls.icon.value"
          [adminMode]="adminMode()"
          [creatorMode]="creatorMode()"
          (channelImageSelected)="onChannelImageSelected($event)"
          (channelSelectedAsDefault)="onChannelSelectedAsDefault($event)"
          (channelsChanged)="onChannelsChanged($event)"
        />
      </div>
    </mat-tab>

    @if (!creatorMode()) {
      <mat-tab #contentsTab>
        <ng-template mat-tab-label>
          <span data-testid="creator-details-tab-contents">{{ 'pages.creatorDetails.tabs.contents' | translate }}</span>
        </ng-template>

        <div class="min-h-[calc(100vh-400px)] pt-[76px]">
          <app-creator-details-social-tiles
            data-testid="creator-details-tab-panel-contents"
            [socialContents]="socialContents()"
            [creator]="creator()"
            [loading]="store.loading$()"
          />
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</app-content-container>
